module.exports = __webpack_public_path__ + "img/logoonly2.704eb35e.png";